import React, { useEffect, useContext, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import SwaggerContext from "../../SwaggerContext";
import { logout } from "../../actions/auth";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";


const RegisterComplete = ({ token }) => {
  const navigate = useNavigate();
  const { userApi } = useContext(SwaggerContext);
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.auth);

  const [status, setStatus] = useState("loading");
  const [lastClick, setLastClick] = useState();

  const [msg, setMsg] = useState("");

  useEffect(() => {
    userApi.validateUser(token, (error, data) => {
      if (error) {
        setStatus("error");
        return;
      }
      if (!data?.status) {
        setStatus("unconfirmed");
      } else {
        setStatus("confirmed");
        
        // Si hay una sesión activa, cerrarla antes de redirigir
        if (isLoggedIn) {
          dispatch(logout(userApi));
        }

        setTimeout(() => navigate("/login"), 5000);
      }
    });
  }, [token, userApi, navigate, dispatch, isLoggedIn]);

  useEffect(() => {
    if (!msg || msg === "") return
    const timer = setTimeout(() => setMsg(""), 10000);
    return () => clearTimeout(timer);
  }, [msg])


  const handleResend = (e) => {
    e.preventDefault();
    setMsg("");


    const now = Date.now();
    if (now - lastClick < 1) {
      setMsg("Has pulsado demasiado rápido. Espera 60 segundos antes de volver a intentarlo.");
      return;
    }


    setLastClick(now);


    userApi.resendValidationMail(token, (error) => {
      if (error) setMsg("Error al reenviar el email.");
      else setMsg("Email reenviado. Revisa tu bandeja de entrada.");
    });
  };

  return (
    <div className="col-md-12">
      <div className="card card-container">
        <img
          src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          alt="profile-img"
          className="profile-img-card"
        />

        {status === "loading" && (
          <div className="alert alert-info text-center" role="alert">
            Validando enlace, espera un momento…
          </div>
        )}

        {status === "error" && (
          <div className="alert alert-danger text-center" role="alert">
            El enlace no es válido o ha expirado. <br />
            <Link to="/register">Registrarse</Link> o <Link to="/login">Iniciar sesión</Link>.
          </div>
        )}

        {status === "unconfirmed" && (
          <>
            <div className="alert alert-warning text-center" role="alert">
              Tu email aún no ha podido ser confirmado, pulsa el botón para recibir un nuevo email de confirmación.
            </div>
            <div className="form-group d-flex justify-content-center pt-3">
              <button onClick={handleResend} className="btn btn-primary">
                Reenviar email de validación
              </button>
            </div>
            {msg && (
              <div className="form-group pt-3">
                <div className="alert alert-info text-center" role="alert">
                  {msg}
                </div>
              </div>
            )}
          </>
        )}

        {status === "confirmed" && (
          <div className="alert alert-success text-center" role="alert">
            Email confirmado correctamente. Serás redirigido al login…
          </div>
        )}
      </div>
    </div>
  );
};

RegisterComplete.propTypes = {
  token: PropTypes.string.isRequired,
};

export default RegisterComplete;